import {useState} from 'react';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/tasks/weekly/deposits';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Autoplay} from 'swiper/modules'
import Diamond from '../diamond';
import Icons from '../icons';

export default () => {
    const {task} = useSelector(Selector),
          [currentSlide, setCurrentSlide] = useState(task ? task.progress.findIndex(x => x.current) : 0)

    if(!task)
        return <></>;

    return (
        <div className="task">
            <div className="task-reward">
                <div className="reward-block">
                    <Diamond />
                    {task.reward}
                </div>
            </div>
            <div className="slide">
                <Swiper
                    modules={[Pagination]}
                    loop={true}
                    slidesPerGroup={1}
                    slidesPerView={1}
                    onInit={(swiper) => {
                        swiper.slideTo(currentSlide);
                    }}
                    onSlideChangeTransitionStart={(swiper) => {
                        console.log(swiper.realIndex);
                        setCurrentSlide(swiper.realIndex);
                    }}>
                    {task.progress.map((day, key) => {
                        return (
                            <SwiperSlide>
                                <div className="task-content" key={key}>
                                    <div className="task-top">
                                        <div className="icon">
                                            {day.className === "success" ? <Icons.Success /> : <></>}
                                            {day.className === "pending" ? <Icons.Pending /> : <></>}
                                            {day.className === "warning" ? <Icons.Warning /> : <></>}
                                        </div>
                                        <div className="task-name">
                                            <span>{day.day}</span>
                                            Week of Deposits
                                        </div>
                                    </div>
                                    <div className="descriptions">
                                        Complete daily $20 deposits to receive diamond rewards.
                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
            <div className="task-bottom">
                <div className="pagination">
                    {task.progress.map((day, key) => {
                        return (
                            <div className={`pagination-page ${day.className} ${key === currentSlide ? 'active' : ''}`} key={key}>
                                {day.className === 'success' ? <Icons.SuccessSmall /> : <></>}
                                {day.className === 'pending' ? <Icons.PendingSmall /> : <></>}
                                {day.className === 'warning' ? <Icons.WarningSmall /> : <></>}
                            </div>
                        )
                    })}
                </div>
                {/* <div className="button">Deposit</div> */}
            </div>
        </div>
    )
}